
import * as Inovx from '@shared';
import assign from 'object-assign';
import { apiPostFormUrlEncoded, FormUrlEncodedBody } from '@shared/api/apiClient';
var UrlUtilities = Inovx.Shared.Common.UrlUtilities;
var url = `${UrlUtilities.getApiUrl()}/FacilityApi/api/Assembly`;

var AssemblyServices: IAssemblyServices = assign({}, Inovx.Shared.Flux.BaseService, {
    
    createAssembly: function (data: IAssembly) {
        return new Promise<IAssembly>((resolve, reject) => {
            apiPostFormUrlEncoded<IAssembly>(url + "/Create", data as FormUrlEncodedBody, { responseType: 'json' })
                .then((result: IAssembly) => {
                    resolve(result);
                })
                .catch((error: any) => {
                    this.handleWebApiError(error);
                    reject(error);
                });
        });
    },
    deleteAssembly: function (Assembly: IAssembly) {
        return new Promise<void>((resolve, reject) => {
            this.post(`${url}/Delete`,
                { id: Assembly.ID, VersionToken: Assembly.VersionToken },
                () => {
                    resolve();
                },
                (error: IServiceErrorObject) => {
                    this.handleWebApiError(error);
                    reject(error);
                }
            );
        });
    },
    updateAssembly: function (data: IAssembly) {
        return new Promise<IAssembly>((resolve, reject) => {
            apiPostFormUrlEncoded<IAssembly>(url + "/Update", data as FormUrlEncodedBody, { responseType: 'json' })
                .then((result: IAssembly) => {
                    resolve(result);
                })
                .catch((error: any) => {
                    this.handleWebApiError(error);
                    reject(error);
                });
        });
    },

    getByKnwoledgeView: function (knowledgeViewID: string) {
        return new Promise<IAssembly[]>((resolve, reject) => {
            this.get(`${url}/ByKnowledgeView`,
                { knowledgeViewID },
                (retData: IAssembly[]) => {
                    resolve(retData);
                },
                (error: IServiceErrorObject) => {
                    this.handleWebApiError(error);
                    reject(error);
                }
            );
        });
    }
});

export default AssemblyServices;